import styled from 'styled-components'

import Button from '../Button/Button'
import IconButton from '../Button/IconButton'

const ButtonGroup = styled.div`
  display: flex;

  ${Button}:first-child {
    flex: 1;
  }

  ${Button}, ${IconButton} {
    padding: 0 10px;
    height: 40px;
    border-radius: 20px;
    border: 0;
  }

  ${IconButton} {
    width: 40px;
  }

  ${Button} + ${Button},
  ${Button} + ${IconButton},
  ${IconButton} + ${IconButton} {
    margin-left: ${props => props.theme.gutter}px;
  }
`

export default ButtonGroup
